import React, { ReactNode } from "react";
import arrow from "../../images/Arrow 13.png";

type Props = {
  children?: ReactNode;
  projets: any;
};

const TravauxCard = ({ projets }: Props) => {
  const uploadUrl = process.env.REACT_APP_FILE_UPLOAD || "";

  return (
    <div className="p-5">
      <div className="transition-all duration-300 bg-white shadow-lg w-80 sm:w-96 h-[360px] rounded-xl hover:shadow-xl flex flex-col">
        <div className="flex justify-center mb-4">
          <div className="relative w-full h-[200px] shadow-inner bg-gradient-to-br from-blue-100 to-blue-300 overflow-hidden">
            <img
              src={uploadUrl ? `${uploadUrl}/projects/${projets.image}` : ""}
              alt={projets.title}
              className="object-cover w-full h-full"
            />
            <div
              className="absolute inset-0"
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))`,
                zIndex: 1,
              }}
            ></div>
          </div>
        </div>
        <h2 className="flex-grow p-2 mb-4 text-sm leading-relaxed text-black text-start sm:text-base line-clamp-3">
          {projets.title}
        </h2>
        <p className="p-2 mb-4 overflow-hidden text-sm leading-6 break-words whitespace-normal text-neutral-500 text-start sm:text-base text-ellipsis line-clamp-3">
          {projets.description.replace(/<[^>]+>/g, "")}
        </p>
        <div className="flex items-center justify-between p-2">
          <span className="text-sm text-primary sm:text-base">
            {projets.date
            ? new Date(projets.createdAt).toLocaleDateString("fr-FR", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })
            : "-"}
          </span>
          <div className="flex items-center justify-between">
            <a
              href={`/travaux/${projets.slug}`}
              className="text-sm font-semibold transition-colors duration-200 text-primary sm:text-base "
            >
              <div className="flex items-center gap-2">
                Lire plus
                <img src={arrow} alt="" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravauxCard;
